import { connect } from 'react-redux';
import * as metaSelectors from 'redux-modules/meta/selectors.js';
import * as uiStateSelectors from 'redux-modules/uiState/selectors.js';
import Language from './Language';

function mapStateToProps(state) {
  return {
    meta: metaSelectors.selectMeta(state),
    supportedLanguages: uiStateSelectors.selectAppLanguageCodes(state)
  };
}

export default connect(mapStateToProps, null)(Language);
